// extracted by mini-css-extract-plugin
module.exports = {"table":"WorklistUploadModal-styles-module--table--2wpU5"};